<template>
  <div class="relative">
    <div class="absolute top-0 right-0 mob-hidden">
      <img src="../../../assets/images/line/abtus-line-1.svg" alt="" />
    </div>
    <div
      class="flex md:w-4/5 lg:w-4/5 w-full mx-auto flex-wrap md:px-0 lg:px-0 px-4 md:pt-24 lg:pt-64 md:items-stretch lg:items-stretch"
    >
      <div
        class="lg:w-1/2 md:w-1/2 lg:pt-0 md:pt-0 w-full my-auto w-full py-12 relative cursor-pointer"
      >
        <div class="my-auto">
          <p class="title md:font-normal lg:font-normal font-bold sm-fsize16">
            Achievements
          </p>

          <div class="lg:pt-5 md:pt-10 pt-4">
            <div class="lg:pt-10 md:pt-10" style="padding-top: 0.5rem">
              <div class="lg:pr-4">
                <p
                  class=" mb-2 subtitle lh32px sm-fsize14"
                  style="margin-bottom: 1rem"
                >
                  Along the way, we’ve been fortunate to have our work recognised and supported by leading institutions and organisations:
                </p>
                <p
                  class=" subtitle lh32px sm-fsize14"
                  style="margin-bottom: 1rem"
                >
                  Incubated by <span class="font-bold">IIM Bangalore’s NSRCEL</span>,  one of India’s leading
                  startup incubators.
                </p>
                <p
                  class=" subtitle lh32px sm-fsize14"
                  style="margin-bottom: 1rem"
                >
                  Incubated by <span class="font-bold"> Shakti – The Empathy  Project </span>  
                 <a href="https://step.in.net"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="step-link"
                >
                  step.in.net
                </a>

                </p>
                <p
                  class=" subtitle lh32px sm-fsize14"
                  style="margin-bottom: 1rem"
                >
                  Part of the learning cohort at <span class="font-bold"> School of Courage</span>, by 
                  Wockhardt Foundation and Accenture.
                </p>
                <p
                  class=" subtitle lh32px sm-fsize14"
                  style="margin-bottom: 1rem"
                >
                  Listed in the <span class="font-bold">IAHPC Global Directory</span> (International
                  Association for Hospice & Palliative Care)
                </p>
                <p
                  class=" mb-2 subtitle lh32px sm-fsize14"
                  style="margin-bottom: 1rem"
                >
                  Awarded <span class="font-bold">NGO of the Year – Empowering Healthcare</span> (2022) by NGO
                  Story.
                </p>
              </div>
              <!-- <div
                class="bgCCEFF2 p-6 rounded-xl z-10 lg:mb-0 md:mb-0 mb-4"
                v-for="(item, index) in medicalcards"
                :key="index"
                :style="{ 'background-color': item.color }"
              >
                <div class="flex justify-between items-center">
                  <p class="text-xl text-black font-semibold">
                    {{ item.text }}
                  </p>
                  <div class="">
                    <img :src="item.img" alt="" class="h-8 w-8" />
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full flex flex-col">
        <div class="achievement-logos">
          <img
            src="../../../assets/images/CGNEW/fellow.png"
            alt="Achievements"
            class="achievement-logo"
          />
          <img
            src="../../../assets/images/CGNEW/ngo_story.png"
            alt="Achievements"
            class="achievement-logo"
          />
          <img
            src="../../../assets/images/CGNEW/wock.png"
            alt="Achievements"
            class="achievement-logo"
          />
          <img
            src="../../../assets/images/CGNEW/accenture.png"
            alt="Achievements"
            class="achievement-logo"
          />
          <img
            src="../../../assets/images/CGNEW/IAHPC.png"
            alt="IAHPC logo"
            class="achievement-logo"
          />
          <img
            src="../../../assets/images/CGNEW/nsrcel-iimb.png"
            alt="NSRCEL IIMB logo"
            class="achievement-logo"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      medicalcards: [
        {
          id: "01",
          text: "Euismod Dolor",
          img: require("../../../assets/images/right.png"),
          color: "#cceff2",
        },
        {
          id: "02",
          text: "Vitae Vivamus",
          img: require("../../../assets/images/right.png"),
          color: "#eee2ff",
        },
        {
          id: "03",
          text: "Euismod Dolor",
          img: require("../../../assets/images/right.png"),
          color: "#eee2ff",
        },
        {
          id: "04",
          text: "Vitae Vivamuss",
          img: require("../../../assets/images/right.png"),
          color: "#cceff2",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style>
.achievement-logos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 0rem 0rem;
  flex: 1;
  height: 100%;
  min-height: 0;
  align-items: center;
  justify-items: center;
}
.achievement-logo {
  width: 100%;
  height: 80%;
  max-width: 160px;
  object-fit: contain;
}
.step-link {
  color: #007bff;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  margin-left: 5px;
}

.step-link:hover {
  text-decoration: underline;
  color: #0056b3;
}

@media (max-width: 767px) {
  .achievement-logos {
    height: auto;
    min-height: 280px;
    margin-top: 1rem;
  }
}
</style>
